const configuration = {
  sentry: {
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  },
} as const;

/**
 * Gets the public configuration for the application. These are public values
 * and safe to be loaded on the client-side.
 * For sensitive values, use `getConfiguration` instead.
 */
export function getClientConfiguration() {
  return configuration;
}
